<template>
  <div :class="wrapperClass">
    <div
      @click.stop="handleOpenPreview"
      :class="`position-relative width--max-content ${
        hasPreview && code ? 'cursor--zoom-in' : ''
      } ${parentTagClass}`"
    >
      <b-img-lazy
        :class="imageClass"
        :src="thumbnail"
        :onerror="`this.src='${defaultImage}';`"
      />
      <span
        v-if="isFetching"
        :class="`position-absolute top-4 flex-center background-complementary-900 opacity-6 color-surface ${loadingClass}`"
      >
        <mdicon name="loading" size="20" class="spinner" />
      </span>
    </div>
    <Teleport to="body">
      <Modal
        :show="isPreview"
        :title="modalTitle"
        :hasFooter="false"
        :hasClose="true"
        :closeOnBackdrop="true"
        size="sm"
        @close="handleClosePreview"
      >
        <template #body>
          <div class="flex items-center justify-center">
            <b-img-lazy
              class="width-percent-100 height-percent-100"
              :src="originalImage"
              :onerror="`this.src='${defaultImage}';`"
            />
          </div>
        </template>
      </Modal>
    </Teleport>
  </div>
</template>
<script>
import Modal from "../modal/Modal.vue";
import { getAttachmentDownloadSrc, getAttachmentOriginal } from "@/services";
import { generateError } from "@/shared/utils";
import { computed, ref, toRefs, watch } from "vue";
import Teleport from "vue2-teleport";
export default {
  components: { Teleport, Modal },
  props: {
    src: {
      type: String,
      default: "",
    },
    defaultImage: {
      type: String,
      default: "",
    },
    wrapperClass: {
      type: String,
      default: "",
    },
    imageClass: {
      type: String,
      default: "width-48 height-48 rounded-lg background-light-gray",
    },
    loadingClass: {
      type: String,
      default: "left-4 width-48 height-48 rounded-lg",
    },
    imageBodyFullWidth: {
      type: Boolean,
      default: false,
    },
    lazy: {
      type: Boolean,
      default: true,
    },
    parentTagClass: {
      type: String,
      default: "",
    },
    hasPreview: {
      type: Boolean,
      default: true,
    },
    modalTitle: {
      type: String,
      default: "پیش نمایش تصویر",
    },
    downloadCode: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const { src, downloadCode, hasPreview } = toRefs(props);
    const code = computed(() => {
      return (
        downloadCode.value ||
        src.value.substring(src.value.lastIndexOf("/") + 1)
      );
    });

    const originalImage = ref("");
    const isPreview = ref(false);
    const isFetching = ref(false);
    const handleOpenPreview = async () => {
      if (!hasPreview.value) return true;
      if (isFetching.value || !code.value) return;

      try {
        isFetching.value = true;
        const { src } = await getAttachmentOriginal(code.value);
        originalImage.value = src;
        isPreview.value = true;
      } catch (error) {
        generateError(error);
      } finally {
        isFetching.value = false;
      }
    };
    const handleClosePreview = () => (isPreview.value = false);

    const thumbnail = ref("");
    const handleGetAttachmentDownloadSrc = async (code) => {
      if (!code) return;

      try {
        isFetching.value = true;
        const { src: imgSrc } = await getAttachmentDownloadSrc(code);
        thumbnail.value = imgSrc;
      } catch (error) {
        generateError(error);
      } finally {
        isFetching.value = false;
      }
    };
    watch(
      code,
      (val) => {
        // check exist code and check is code
        if (val && !val.includes(".")) {
          handleGetAttachmentDownloadSrc(val);
        }
      },
      { immediate: true }
    );

    return {
      handleOpenPreview,
      handleClosePreview,
      isFetching,
      originalImage,
      isPreview,
      code,
      thumbnail,
    };
  },
};
</script>
